const START_A = 'SA';
const START_B = 'SB';
const START_C = 'SC';
const START_D = 'SD';

const END_A = 'EA';
const END_B = 'EB';
const END_C = 'EC';
const END_D = 'ED';

export const CELLS = {
    START_A,
    START_B,
    START_C,
    START_D,
    END_A,
    END_B,
    END_C,
    END_D,
};

export type CellType = typeof CELLS[keyof typeof CELLS];


const ON_ADD = 'ON_ADD';
const ON_SAVE = 'ON_SAVE';

export const CHANGE_TYPE = {
    ON_ADD,
    ON_SAVE,
};

export type ChangeType = typeof CHANGE_TYPE[keyof typeof CHANGE_TYPE];
